<template>
  <div
    id="roleFormModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-toolbar">
                <ul
                  class="nav nav-tabs nav-tabs-line nav-tabs-line-info nav-tabs-line-2x"
                  role="tablist"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      data-toggle="tab"
                      href="#tabRoleInformation"
                      role="tab"
                    >
                      <i class="la la-cog"></i> ข้อมูลพื้นฐาน
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#tabRolePermissions" role="tab">
                      <i class="la la-briefcase"></i> การเข้าถึงหน้าจอ
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="tab-content">
                <div class="tab-pane active" id="tabRoleInformation" role="tabpanel">
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <label class="label-required">ชื่อบทบาท:</label>
                        <input
                          :disabled="isEdit"
                          id="roleName"
                          name="roleName"
                          v-model="roleName"
                          type="text"
                          maxlength="256"
                          class="form-control"
                          placeholder="ชื่อบทบาท"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <label class="label-required">คำอธิบาย:</label>
                        <input
                          id="description"
                          name="description"
                          v-model="description"
                          type="description"
                          maxlength="450"
                          class="form-control"
                          placeholder="คำอธิบาย"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="tabRolePermissions" role="tabpanel">
                  <v-jstree
                    :data="roleClaims"
                    ref="roleClaims"
                    show-checkbox
                    multiple
                    allow-batch
                    whole-row
                    @item-click="claimClick"
                  ></v-jstree>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> บันทึกข้อมูล
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      isEdit: false,
      roleName: null,
      description: null,
      roleClaims: [
        {
          text: "แดชบอร์ด",
          value: "DASHBOARD",
          opened: true,
          selected: true,
          disabled: true
        },
        {
          text: "ข้อมูลพื้นฐาน",
          value: "MASTER",
          opened: false,
          selected: false,
          children: [
            {
              text: "สมาชิก",
              value: "MASTER_USER",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลสมาชิก",
                  value: "MASTER_USER_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลสมาชิก",
                  value: "MASTER_USER_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลสมาชิก (ข้อมูล, รหัสผ่าน, รีเซ็ตรหัสผ่าน)",
                  value: "MASTER_USER_EDIT",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "บทบาท",
              value: "MASTER_ROLE",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลบทบาท",
                  value: "MASTER_ROLE_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลบทบาท",
                  value: "MASTER_ROLE_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลบทบาท",
                  value: "MASTER_ROLE_EDIT",
                  opened: true,
                  selected: false
                },
                {
                  text: "ลบข้อมูลบทบาท",
                  value: "MASTER_ROLE_DELETE",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "จัดการไฟล์",
              value: "MASTER_FILE_MANAGER",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านไฟล์",
                  value: "MASTER_FILE_MANAGER_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "อัพโหลดไฟล์",
                  value: "MASTER_FILE_MANAGER_UPLOAD",
                  opened: true,
                  selected: false
                },
                {
                  text: "ลบไฟล์",
                  value: "MASTER_FILE_MANAGER_DELETE",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "ระยะเวลาถือครองสินค้า",
              value: "MASTER_HOLDING",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลการถือครอง",
                  value: "MASTER_HOLDING_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลการถือครอง",
                  value: "MASTER_HOLDING_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลการถือครอง",
                  value: "MASTER_HOLDING_EDIT",
                  opened: true,
                  selected: false
                },
                {
                  text: "ลบข้อมูลการถือครอง",
                  value: "MASTER_HOLDING_DELETE",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "รายงานความเคลื่อนไหว",
              value: "SEARCHBEER",
              opened: true,
              selected: true,
              disabled: true
            },
            {
              text: "การจัดการข้อมูลตัวแทนจำหน่าย",
              value: "AGENT",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลตัวแทนจำหน่าย",
                  value: "AGENT_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลตัวแทนจำหน่าย",
                  value: "AGENT_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลตัวแทนจำหน่าย(Excel)",
                  value: "AGENT_CREATE_EXCEL",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
                  value: "AGENT_EDIT",
                  opened: true,
                  selected: false
                },
                {
                  text: "ลบข้อมูลตัวแทนจำหน่าย",
                  value: "AGENT_DELETE",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "จัดการงบประมาณรายแบรนด์",
              value: "BRAND",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลงบประมาณรายแบรนด์",
                  value: "BRAND_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลงบประมาณแบรนด์",
                  value: "BRAND_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
                  value: "AGENT_EDIT",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "จัดการ Stock สินค้า",
              value: "STOCKPRODUCT",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลงบประมาณรายแบรนด์",
                  value: "STOCK_PRODUCT_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
                  value: "STOCK_PRODUCT_EDIT",
                  opened: true,
                  selected: false
                }
              ]
            },
            {
              text: "อัพโหลดง Stock รายแบรนด์",
              value: "STOCKPRODUCT",
              opened: true,
              selected: false
            },
            {
              text: "จัดการข้อมูลการเบิก/ยืม",
              value: "MANAGE_ฺBORROW_PRODUCT",
              opened: true,
              selected: false,
              children: [
                {
                  text: "อ่านข้อมูลการเบิก/ยืม",
                  value: "MANAGE_ฺBORROW_PRODUCT_GET",
                  opened: true,
                  selected: false
                },
                {
                  text: "เพิ่มข้อมูลการเบิก/ยืม",
                  value: "MANAGE_ฺBORROW_PRODUCT_CREATE",
                  opened: true,
                  selected: false
                },
                {
                  text: "แก้ไขข้อมูลการเบิก/ยืม",
                  value: "MANAGE_ฺBORROW_PRODUCT_EDIT",
                  opened: true,
                  selected: false
                },
                {
                  text: "ลบข้อมูลการเบิก/ยืม",
                  value: "MANAGE_ฺBORROW_PRODUCT_DELETE",
                  opened: true,
                  selected: false
                }
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    claimClick: function(node) {
      var selfParent = node.$parent;
      while (selfParent.model) {
        if (selfParent.model.children.length > 0) {
          // Force selected is true . we will set it depending on children
          selfParent.model.selected = true;
        }
        for (let i = 0; i < selfParent.model.children.length; i++) {
          const child = selfParent.model.children[i];
          selfParent.model.selected =
            selfParent.model.selected && child.selected;
        }
        selfParent = selfParent.$parent;
      }
    },
    getSelectedClaims: function(parent) {
      if (!parent) {
        var pClaims = [];
        for (let pi = 0; pi < this.roleClaims.length; pi++) {
          const p = this.roleClaims[pi];
          pClaims = pClaims.concat(this.getSelectedClaims(p));
        }
        return pClaims;
      }

      var claims = [];
      if (parent.selected) {
        claims.push(parent.value);
      }

      if (parent.children) {
        for (let i = 0; i < parent.children.length; i++) {
          const child = parent.children[i];
          claims = claims.concat(this.getSelectedClaims(child));
        }
      }
      return claims;
    },
    setSelectedClaims: function(selected, claims) {
      if (Array.isArray(selected)) {
        for (let i = 0; i < selected.length; i++) {
          const s = selected[i];
          this.setSelectedClaims(s, this.roleClaims);
        }
      } else if (typeof selected === "string" && claims) {
        for (let i = 0; i < claims.length; i++) {
          const cl = claims[i];
          if (!cl.selected) {
            cl.selected = cl.value === selected;
          }
          this.setSelectedClaims(selected, cl.children);
        }
      }
    },
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#roleFormModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      let router = this.$router;
      axios
        .post(this.isEdit ? "/Api/Roles/Update" : "/Api/Roles/Create", {
          roleName: this.roleName,
          description: this.description,
          roleClaims: this.getSelectedClaims()
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#roleFormModal").modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  mounted() {
    let self = this;
    let router = this.$router;

    // set validation rules
    $("#roleFormModal form").validate({
      rules: {
        roleName: {
          required: true,
          regex: "^[a-zA-Z0-9_]+$"
        },
        description: "required"
      },
      messages: {
        roleName: {
          required: "กรุณากรอกชื่อบทบาท",
          regex:
            "ชื่อบทบาทสามารถประกอบไปด้วยตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น และไม่สามารถเว้นช่องว่างหรือใส่อักขระพิเศษได้"
        },
        description: "กรุณาคำอธิบาย"
      }
    });

    $("#roleFormModal").on("hidden.bs.modal", function() {
      // Set go back
      router.go(-1);
      self.$parent.reloadDataTable(false);
    });

    if (this.$route.params.roleName) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      axios
        .get("/Api/Roles/" + this.$route.params.roleName)
        .then(function(response) {
          if (response.status == 200) {
            self.isEdit = true;
            self.roleName = self.$route.params.roleName;
            self.description = response.data.description;
            self.setSelectedClaims(response.data.roleClaims);

            $("#roleFormModal").modal("show");
          } else {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "ไม่พบข้อมูลบทบาทที่คุณเลือก",
              "warning"
            );
            router.go(-1);
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลบทบาทได้ในขณะนี้",
            "error"
          );
          router.go(-1);
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    } else {
      $("#roleFormModal").modal("show");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Role/RoleForm.vue